import axios from 'axios';

import { headers, STOCK } from '../../config';

function search(data) {
    if(!data) data = ""
    return axios.get(`${STOCK}/item-types`, { headers: headers(), params: data })
}
export default {
    search
}